import { render, staticRenderFns } from "./Dashboard2Page.vue?vue&type=template&id=5bfbfc60&scoped=true&"
import script from "./Dashboard2Page.vue?vue&type=script&lang=js&"
export * from "./Dashboard2Page.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard2Page.vue?vue&type=style&index=0&id=5bfbfc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbfc60",
  null
  
)

export default component.exports